<span class="text__sm fw__500">{{ label() }}</span>
<span class="text__lg fw__600">
  @if (isLoading()) {
    <mat-spinner diameter="20" color="light" />
  } @else {
    <ng-content />
  }
</span>
